$(document).on('click', '.select-currency .cur-item:not(.active)', function(){
    let elem = $(this)
    let cur = elem.data('cur')

    requestAjax('set_currency', cur, () => {
        window.location.reload()
    })
})